import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import ENDPOINTS from '../../constants/endpoints';
import { client } from '../../helper/apiCall';





export const createMatch = createAsyncThunk(
  'matches/createMatch',
  async (body, { rejectWithValue, getState }) => {
    try {
      const response = await client.post(ENDPOINTS.MATCHES.CREATE, body, {
        token: getState().auth.token
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Bir hata oluştu');
    }
  }
);

export const fetchMatchesByAgeGroup = createAsyncThunk(
  'matches/fetchByAgeGroup',
  async (body, { rejectWithValue, getState }) => {
    try {
      const response = await client.post(ENDPOINTS.MATCHES.GET_LIST + `/By-Age-Group`, body, {
        token: getState().auth.token
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Bir hata oluştu');
    }
  }
);

export const deleteMatch = createAsyncThunk(
  'matches/delete',
  async (id, thunkAPI) => {
    try {
      const response = await client.delete(ENDPOINTS.MATCHES.DELETE.replace(':id', id), null, {
        token: thunkAPI.getState().auth.token
      });
      return { id, ...response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const updateMatch = createAsyncThunk(
  'matches/updateMatch',
  async (body, { rejectWithValue, getState }) => {
    try {
      const response = await client.put(ENDPOINTS.MATCHES.UPDATE, body, {
        token: getState().auth.token
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Bir hata oluştu');
    }
  }
);

const matchesSlice = createSlice({
  name: 'matches',
  initialState: {
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMatchesByAgeGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMatchesByAgeGroup.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(fetchMatchesByAgeGroup.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createMatch.pending, (state) => {
        state.loading = true;
      })
      .addCase(createMatch.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createMatch.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteMatch.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteMatch.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteMatch.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateMatch.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateMatch.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateMatch.rejected, (state, action) => {
        state.loading = false;
      })
  }
});

export default matchesSlice.reducer;


